import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Dash from './Dash';

export default class Projects extends Component {
  static propTypes = {
    children: PropTypes.node,
  }
  static contextTypes = {
    store: PropTypes.object,
  }

  static Dash = Dash

  render() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Media/Media.jsx